import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/BackgroundAsImageWithCenteredContent.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import tw from "twin.macro";
import MainFeature from "components/features/TwoColWithButton.js";
import ThreeColSlider from "components/cards/ThreeColSlider";
import GetStartedLight from "components/cta/GetStartedLight";
import TwoTrendingPreviewCardsWithImage from "components/cards/TwoTrendingPreviewCardsWithImage";

const Subheading = tw.span`tracking-wider text-sm font-medium`;
const HighlightedText = tw.span`bg-orange-600 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const Description = tw.span`inline-block mt-8`;
const imageCss = tw`rounded-4xl`;

export default () => (
  <AnimationRevealPage>
    <Hero />

    <MainFeature
      subheading={<Subheading>Fundado em 2020</Subheading>}
      heading={
        <>
          Estamos produzindo mel há
          <wbr /> <HighlightedText>mais de 3 anos.</HighlightedText>
        </>
      }
      description={
        <Description>
          Nosso mel é produzido com as melhores práticas de apicultura, garantindo qualidade e sabor excepcionais.
          <br />
          <br />
          Trabalhamos com dedicação para oferecer o melhor mel natural, direto da colmeia para a sua mesa.
        </Description>
      }
      buttonRounded={false}
      textOnLeft={false}
      primaryButtonText="Nossos Produtos"
      primaryButtonUrl="#products-container"
      imageSrc={
        "/assets/bisnagas.png"
      }
      imageCss={imageCss}
      imageDecoratorBlob={true}
      imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
    />

    <TwoTrendingPreviewCardsWithImage />

    
    <ThreeColSlider />

    <GetStartedLight
      subheading="Ficou interessado?"
      heading="Entre em contato conosco"
      primaryLinkText="Contate-nos"
      primaryLinkUrl="https://wa.me/5562985174521?text=Ol%C3%A1%2C%20Gostaria%20de%20comprar%20um%20de%20seus%20produtos!" 
    
    />
    <Footer />
  </AnimationRevealPage>
);
